import React from "react";
import "chart.js/auto";
import { Doughnut } from "react-chartjs-2";

import { useEnquiryAnalyticsQuery } from "state/api";
import Loader from "components/Loader";


const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "left",
    },
    title: {
      display: true,
      text: "Call Status Trends",
    },
    colors: {
      enabled: true,
    },
  },
};

const CallStatusTrends = () => {
  let { data: callStatusStats, isLoading } = useEnquiryAnalyticsQuery();
  callStatusStats = {
    ...callStatusStats?.callStatusTrends,
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Doughnut
          data={{
            labels: callStatusStats?.labels,
            datasets: [
              {
                label: "# of Responses",
                data: callStatusStats?.data,
                borderWidth: 1,
              },
            ],
          }}
          options={options}
        />
      )}
    </>
  );
};

export default CallStatusTrends;
